exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 600px) {\n.fund-types .big-mobile {\n    width: 50%;\n    margin-bottom: 24px;\n}\n}\n@media (max-width: 850px) and (orientation: landscape) {\n.fund-types .big-mobile {\n    width: 50%;\n    margin-bottom: 24px;\n}\n}\n", ""]);
